export default __webpack_public_path__ + "static/media/about.e28eeddf.jpg";